import fetch from './fetch'

export function getIntentSecret(
  planId: string,
  couponCode: string
): Promise<api.stripe.GetIntentSecret> {
  return fetch
    .get('/stripe_042ce1d98e7099d76917/intent_secret', {
      params: { plan_id: planId, coupon_code: couponCode }
    })
    .then(res => res.data)
}
